import { createContext } from "react";
import { modelInputProps } from "../helpers/Interface";

type Setter<T> = React.Dispatch<React.SetStateAction<T>>;

interface contextProps {
  click: [modelInputProps | null, (value: modelInputProps | null) => void];
  clicks: [modelInputProps[] | null, (value: modelInputProps[] | null) => void];
  clicksHistory: [modelInputProps[] | null, (value: modelInputProps[] | null) => void];
  image: [HTMLImageElement | null, (value: HTMLImageElement | null) => void];
  prevImage: [HTMLImageElement | null, (value: HTMLImageElement | null) => void];
  isLoading: [boolean, (value: boolean) => void];
  isErasing: [boolean, (value: boolean) => void];
  isErased: [boolean, (value: boolean) => void];
  error: [boolean, (value: boolean) => void];
  svg: [string[] | null, (value: string[] | null) => void];
  svgs: [string[][] | null, (value: string[][] | null) => void];
  allsvg: [
    { svg: string[]; point_coord: number[] }[] | null,
    (value: { svg: string[]; point_coord: number[] }[] | null) => void
  ];
  stickers: [HTMLCanvasElement[], (value: HTMLCanvasElement[]) => void];
  activeSticker: [number, (value: number) => void];
  isModelLoaded: [
    { boxModel: boolean; allModel: boolean },
    Setter<{ boxModel: boolean; allModel: boolean }>
  ];
  segmentTypes: ["Box" | "Click" | "All", (value: "Box" | "Click" | "All") => void];
  canvasWidth: [number, (value: number) => void];
  canvasHeight: [number, (value: number) => void];
  maskImg: [HTMLImageElement | null, (value: HTMLImageElement | null) => void];
  maskCanvas: [HTMLCanvasElement | null, (value: HTMLCanvasElement | null) => void];
  userNegClickBool: [boolean, (value: boolean) => void];
  hasNegClicked: [boolean, (value: boolean) => void];
  stickerTabBool: [boolean, Setter<boolean>];
  enableDemo: [boolean, Setter<boolean>];
  isMultiMaskMode: [boolean, Setter<boolean>];
  isHovering: [boolean | null, Setter<boolean | null>];
  showLoadingModal: [boolean, Setter<boolean>];
  eraserText: [
    { isErase: boolean; isEmbedding: boolean },
    Setter<{ isErase: boolean; isEmbedding: boolean }>
  ];
  didShowAMGAnimation: [boolean, Setter<boolean>];
  predMask: [string | null, Setter<string | null>];
  predMasks: [string[] | null, Setter<string[] | null>];
  predMasksHistory: [string[] | null, Setter<string[] | null>];
  isAllAnimationDone: [boolean, Setter<boolean>];
  isToolBarUpload: [boolean, Setter<boolean>];
}

const AppContext = createContext<contextProps | null>(null);

export default AppContext;
